export const API_BASE_URL = `${import.meta.env.VITE_URL_SCHEME}://${
  import.meta.env.VITE_API_BASE_URL
}/managements/${import.meta.env.VITE_API_VERSION}`

export const DOWNLOAD_BASE_URL = `${import.meta.env.VITE_URL_SCHEME}://${
  import.meta.env.VITE_API_BASE_URL
}`
